export const translationHashes = {
  "de-DE": "0f9c3790",
  "en-CA": "d29ea7a1",
  "en-GB": "17dfc7b5",
  "en-US": "04cf62d4",
  "es-ES": "9afac406",
  "es-US": "e1c10b9b",
  "formattings": "3b5d04b6",
  "fr-CA": "0df8b483",
  "nl-NL": "24e03019",
  "sv-SE": "2887f0c6"
} as {[lang: string]: string};